import Page from '~/components/Shared/Layout/Page/Page';
import Heading from '~/components/Shared/Heading/Heading';
import { TransactionsBoard } from './TransactionsBoard/TransactionsBoard';
import { useTranslation } from 'react-i18next';
import { AuthenticationContext } from '~/components/Authentication/AuthenticationProvider';
import { useContext, useState } from 'react';
import { checkIfFoodAdmin } from '~/utils/getUserRole';
import { TransactionsFoodAdminBoard } from '../Transaction/TransactionsFoodAdminBoard/TransactionsFoodAdminBoard';
import { TransactionsPageInfo } from './TransactionsPageInfo/TransactionsPageInfo';
import dayjs, { Dayjs } from 'dayjs';

export const Transactions = (): JSX.Element => {
  const { t } = useTranslation();
  const { user } = useContext(AuthenticationContext);
  const isFoodAdminAccess = checkIfFoodAdmin(user?.data.role_name);
  const [statusFilter, setStatusFilter] = useState('');
  const [dates, setDates] = useState<[Dayjs, Dayjs]>([
    dayjs().subtract(1, 'week'),
    dayjs(),
  ]);

  return (
    <Page heading={<Heading text={t('orders')} />}>
      {isFoodAdminAccess ? (
        <TransactionsFoodAdminBoard />
      ) : (
        <>
          <TransactionsPageInfo
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            dates={dates}
          />
          <TransactionsBoard
            statusFilter={statusFilter}
            dates={dates}
            onDatesChange={setDates}
          />
        </>
      )}
    </Page>
  );
};
